
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchInstitutionalDownloads } from './fetch-institutional-downloads';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  initialData?: P | null
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-institutional-downloads`;
};

/**
 * `useInstitutionalDownloads` hook.
 */

function useInstitutionalDownloads<P>({ initialData }: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const result = useQuery([actionType(variables), variables], () => {
    return fetchInstitutionalDownloads(variables);
  }, {
    initialData
  });

  return result;
}

/**
 * Export `useInstitutionalDownloads` hook.
 */

export default useInstitutionalDownloads;
